<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Didalam Geolokasi',
      required: false,
    },
    data: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: 'all',
    },
  },

  data() {
    return {
      phaseOneShow: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      formattedData: [],
      isBusy: true,
    }
  },

  computed: {
    /**
     * Total no. of records
     */
    totalData() {
      return this.formattedData.length
    },

    fields() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('global.object.licensePlate'),
          sortable: true,
        },
        {
          key: 'vehicleGroup',
          label: this.$t('global.object.fleetGroup'),
          sortable: true,
        },
        {
          key: 'timeInGeofence',
          label:
            this.type === 'all'
              ? this.$t('dashboard.label.geolocationDuration')
              : this.$t('dashboard.label.durationInGeolocation'),
          sortable: true,
        },
      ]
    },
  },

  watch: {
    data: {
      handler(val) {
        this.formatData(val)
      },
      deep: false,
    },
  },

  created() {
    this.formatData(this.data)
  },

  methods: {
    formatData(data) {
      this.isBusy = true
      const tempData = []
      data.forEach((row) => {
        const index = tempData.findIndex((x) => x.id == row.id)
        if (index < 0) {
          tempData.push(row)
        } else {
          tempData[index].vehicleGroup += !tempData[index].vehicleGroup.includes(row.vehicleGroup)
            ? `, ${row.vehicleGroup}`
            : ''
          tempData[index].timeInGeofence += !tempData[index].timeInGeofence.includes(
            row.timeInGeofence
          )
            ? `, ${row.timeInGeofence}`
            : ''
        }
      })

      this.formattedData = [...tempData]
      this.isBusy = false
    },
    onHide() {
      this.currentPage = 1
      this.perPage = 10
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      modal-class="mc-modal-dashboard"
      id="modal-pool"
      ref="modal-pool"
      :title="label || $t('dashboard.title.insideGeolocation')"
      header-close-variant="light"
      :ok-title="$t('global.action.close')"
      ok-variant="outline-primary"
      ok-only
      size="lg"
      centered
      scrollable
      @hidden="onHide"
    >
      <div class="table-responsive my-3 border border-1">
        <b-table
          small
          show-empty
          :fields="fields"
          :items="formattedData"
          class="datatables"
          responsive="sm"
          sort-by="licensePlate"
          empty-table
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="isBusy"
        >
        </b-table>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              {{ $t('global.text.display') }}
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
              {{ $t('global.text.entries') }}.
              {{ totalData > 0 ? (currentPage - 1) * perPage + 1 : 0 }} -
              {{ Math.min(totalData, currentPage * perPage) }} {{ $t('global.object.of') }}
              {{ totalData }}
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="totalData"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
